module.exports = __webpack_public_path__ + "img/modules1.0de869f0.png";